const prepositions = `
  <p>
    German prepositions are being used in four cases. One of the cases is the accusative case, which is very commonly used in everyday German. Between prepositions, that take the accusative are:
  </p>
  <div>
    <h3>bis (by, to, until)</h3>
    <h4>Examples:</h4>
    <p>
      <strong>Bitte schicken Sie Ihre Bewerbung bis Freitag.</strong>
    </p>
    <p>
      Please send your application by Friday.
    </p>
    <p>
      <strong>Sie hat Zeit bis sechs.</strong>
    </p>
    <p>
      She has time until six.
    </p>
    <h3>um (at, around, about)</h3>
    <h4>Examples:</h4>
    <p>
      <strong>Wir treffen uns um acht.</strong>
    </p>
    <p>
      We are meeting at eight.
    </p>
    <h3>für (for)</h3>
    <h4>Examples:</h4>
    <p>
      <strong>Danke für Ihre Hilfe.</strong>
    </p>
    <p>
      Thank you for your help.
    </p>
    <h3>gegen (against)</h3>
    <h4>Examples:</h4>
    <p>
      <strong>Er ist gegen diesen Vorschlag.</strong>
    </p>
    <p>
      He is against this proposal.
    </p>
    <h3>ohne (without)</h3>
    <h4>Examples:</h4>
    <p>
      <strong>Ohne Martin haben wir keine Chance gegen die andere Mannschaft.</strong>
    </p>
    <p>
      Without Martin, we have no chance against the other team.
    </p>
  </div>
`

export default prepositions



// WEBPACK FOOTER //
// ./src/browser/grammar/languages/german/grammar-descriptions/prepositions.js